import DashboardIncidentsMainAgency from './DashboardIncidentsMainAgency';

export default DashboardIncidentsMainAgency;
